export default "__VITE_ASSET__CXg2GeYe__"